import React from 'react';
import { motion } from 'framer-motion';
export function DreamOutcome() {
  return <section className="w-full bg-[#FDF8F4]/80 py-16 md:py-24" data-id="element-18">
      <motion.div className="max-w-3xl mx-auto px-6" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-19">
        <h2 className="font-lora text-3xl md:text-4xl font-bold text-charcoal mb-8" data-id="element-20">
          Imagina despertar mañana y tener el control
        </h2>

        <div className="font-inter text-lg text-charcoal/90 leading-relaxed space-y-6" data-id="element-21">
          <p data-id="element-22">
            Imagina despertar mañana y, antes de que tu mente empiece a hacer su
            lista de catástrofes, tener una herramienta. Un protocolo. Un
            interruptor que sabes exactamente cómo presionar.
          </p>

          <p data-id="element-23">
            Imagina estar en esa reunión, sentir que el pánico empieza a subir,
            y en lugar de entrar en pánico por el pánico, simplemente activar el
            protocolo. 60 segundos. Nadie lo nota. Y ya está. La ola pasa.
          </p>

          <p data-id="element-24">
            Imagina ir al supermercado, al trabajo, a la fiesta de cumpleaños de
            tu hijo, sin esa sombra constante de "¿y si me pasa algo aquí?".
          </p>

          <p className="font-semibold text-sage text-xl" data-id="element-25">
            No es un sueño lejano. Es biología. Y la biología se puede
            reprogramar.
          </p>
        </div>

        <motion.div className="mt-12" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} data-id="element-26">
          <a href="#comprar" className="inline-block bg-sage text-white font-inter font-semibold px-8 py-4 rounded-lg hover:bg-sage/90 transition-colors duration-200" data-id="element-27">
            Quiero Mi Protocolo de Calma Ahora
          </a>
        </motion.div>
      </motion.div>
    </section>;
}